// Scrollbar global para web: fina y siempre visible (no overlay).
// Se inyecta una sola vez en <head>. En nativo se usa el no-op de globalScrollbar.ts.
const GLOBAL_SCROLLBAR_CSS = `
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(81, 12, 118, 0.30) transparent;
}
*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
*::-webkit-scrollbar-thumb {
  background-color: rgba(81, 12, 118, 0.30);
  border-radius: 999px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}

/* Foco de campos: quitar el contorno negro del navegador y poner un anillo morado suave
   (el principal al 50%) que sigue el contorno redondeado del campo, vía box-shadow. */
input:focus,
select:focus,
textarea:focus,
[contenteditable]:focus {
  outline: none;
  box-shadow: 0 0 0 1px #510C76;
}
`;

if (typeof document !== 'undefined' && !document.getElementById('global-scrollbar-style')) {
  const style = document.createElement('style');
  style.id = 'global-scrollbar-style';
  style.textContent = GLOBAL_SCROLLBAR_CSS;
  document.head.appendChild(style);
}

export {};
